/**
 * Novidades para quem USA o app.
 *
 * Regra da casa (igual agenda_project, finance_project, service_project e
 * Forja3D): depois de implementar algo perceptivel pelo cliente final --
 * funcionalidade nova, melhoria de uso, correcao de um problema que ele sentia
 * -- acrescente uma entrada NO TOPO desta lista.
 *
 *   * `tag`: 'novidade' | 'melhoria' | 'correcao'
 *   * `title` e `text` sao lidos pela pessoa: escreva o beneficio em linguagem
 *     simples, sem jargao. "Agora você pode..." e nunca "feat: add endpoint".
 *   * `date` em ISO com hora -- e o que ordena a lista e define o que ainda
 *     nao foi visto (comparado com usuarios.changelog_visto_em).
 *   * NAO registre refactor, infra, teste ou ajuste interno: so o que a pessoa
 *     percebe.
 */
export type TagChangelog = 'novidade' | 'melhoria' | 'correcao';

export interface EntradaChangelog {
  id: string;
  date: string;
  tag: TagChangelog;
  title: string;
  text: string;
}

export const CHANGELOG: readonly EntradaChangelog[] = [
  {id:'2026-10-12-pix-direto',date:'2026-10-12T19:00:00Z',tag:'novidade',title:'Pix direto para o profissional',text:'Profissionais com plano podem cadastrar a própria chave Pix e receber o Pix do cliente direto na conta, sem taxa. O cartão continua pelo app, com o dinheiro guardado até o fim do serviço.'},
  {id:'2026-10-12-termos',date:'2026-10-12T19:00:01Z',tag:'melhoria',title:'Termos e Privacidade atualizados',text:'Explicamos como funciona o Pix direto ao profissional. Na próxima vez que entrar, vamos pedir que você leia e concorde com a versão nova.'},
  {id:'2026-10-12-oficios-fotos',date:'2026-10-12T16:00:00Z',tag:'melhoria',title:'Conheça os ofícios pela foto',text:'A página inicial mostra, com imagens, profissionais de vários ofícios trabalhando em casa: elétrica, encanamento, pintura, limpeza, jardinagem e outros. Toque num deles para saber o que perguntar antes de chamar.'},
  {id:'2026-10-11-termos',date:'2026-10-11T22:05:00Z',tag:'melhoria',title:'Termos e Privacidade atualizados',text:'Atualizamos os Termos de Uso e a Política de Privacidade. Na próxima vez que entrar, vamos pedir que você leia e concorde com a versão nova.'},
  {id:'2026-10-11-sugestoes',date:'2026-10-11T22:00:00Z',tag:'novidade',title:'Quadro de sugestões',text:'O Chama Um está sempre melhorando, e queremos que você participe. No menu da sua conta, em Sugestões, mande ideias e apoie as de outras pessoas.'},
  {id:'2026-10-11-avaliacao-foto',date:'2026-10-11T21:00:00Z',tag:'novidade',title:'Mostre o serviço com fotos',text:'Depois de avaliar, você pode juntar até 3 fotos de como ficou o serviço. A nossa equipe olha antes de elas aparecerem no perfil do profissional.'},
  {id:'2026-10-11-servico-na-cidade',date:'2026-10-11T20:00:00Z',tag:'melhoria',title:'Página do serviço na sua cidade',text:'Agora cada tipo de serviço tem uma página para a sua cidade, e o link de um profissional enviado pelo WhatsApp aparece com o nome dele.'},
  {id:'2026-10-11-emergencia',date:'2026-10-11T19:00:00Z',tag:'novidade',title:'Pedido de emergência chega primeiro a quem atende',text:'Quando você marca o pedido como emergência, ele vai antes para os profissionais que atendem emergência, com um aviso de urgência.'},
  {id:'2026-10-11-excluir-conta-pagamento',date:'2026-10-11T18:00:00Z',tag:'melhoria',title:'Excluir a conta apaga também seus cartões',text:'Quando você exclui a sua conta, pedimos às empresas de pagamento que apaguem o seu cadastro e os cartões guardados.'},
  {id:'2026-10-11-termos-pix-devolucao',date:'2026-10-11T17:00:00Z',tag:'melhoria',title:'Termos de uso atualizados',text:'Explicamos o que acontece quando o banco de quem pagou um Pix pede a devolução por suspeita de fraude: o dinheiro fica guardado e a equipe analisa com as duas partes.'},
  {id:'2026-10-11-pedido-coberto',date:'2026-10-11T16:00:00Z',tag:'novidade',title:'Avisamos quando chega profissional',text:'Se ninguém da sua cidade fazia o serviço que você pediu, agora mandamos o pedido assim que alguém começar a atender e avisamos você.'},
  {id:'2026-10-11-privacidade-pedido',date:'2026-10-11T16:00:00Z',tag:'melhoria',title:'Política de privacidade atualizada',text:'Explicamos como guardamos, por pouco tempo, os cuidados de atendimento que você marca no pedido.'},
  {id:'2026-10-11-conversa-no-pedido',date:'2026-10-11T14:00:00Z',tag:'correcao',title:'Conversa e valor certos no pedido',text:'A conversa com o profissional agora aparece dentro do pedido, para você e para ele. E o valor total, já com a proteção, aparece antes de você aceitar o orçamento.'},
  {id:'2026-10-11-fotos-sem-localizacao',date:'2026-10-11T14:00:00Z',tag:'melhoria',title:'Suas fotos sem localização',text:'Quando você envia uma foto, tiramos dela a localização e os dados do celular que a câmera grava sem você ver. Assim ninguém descobre onde a foto foi tirada.'},
  {id:'2026-10-04-landing-fotografica',date:'2026-10-04T23:30:00Z',tag:'melhoria',title:'Conheça melhor o Chama Um',text:'A página inicial ganhou fotografias e um convite para profissionais. Veja como funciona e cadastre-se para a avaliação da equipe.'},
  {id:'2026-10-04-ana-por-voz',date:'2026-10-04T23:00:00Z',tag:'novidade',title:'Fale com a Ana',text:'Agora você pode falar em vez de escrever: toque no microfone na conversa com a Ana. Ela também pode ler as respostas em voz alta. Escolha como prefere em Minha conta, no painel Acessibilidade.'},
  {id:'2026-10-04-ana-na-barra',date:'2026-10-04T21:00:00Z',tag:'melhoria',title:'Conheça a Ana',text:'A Ana ganhou rosto: ela pisca, escuta enquanto você escreve, pensa e comemora quando dá certo. No celular, fica no meio da barra de baixo. Sua conta continua no menu do topo.'},
  {id:'2026-10-04-selo-parceiro',date:'2026-10-04T18:00:00Z',tag:'novidade',title:'Selo de Profissional Parceiro',text:'Profissionais parceiros do Chama Um agora têm um selo no cartão e no perfil, e aparecem primeiro na busca.'},
  {id:'2026-10-04-central-ajuda',date:'2026-10-04T16:00:00Z',tag:'novidade',title:'Ajuda dentro do app',text:'A conversa com a Ana agora abre na própria tela, mais rápida. Se precisar, uma pessoa da equipe continua a conversa ali mesmo, e você acompanha suas solicitações na Central de ajuda.'},
  {
    id: '2026-10-04-ana-assistente',
    date: '2026-10-04T15:00:00Z',
    tag: 'novidade',
    title: 'Peça à Ana e ela faz por você',
    text: 'No botão de ajuda, diga o que precisa: a Ana procura profissionais, cria o pedido, manda mensagem, aceita o orçamento, marca o horário, paga e aumenta a letra. Para pagar ou cancelar, ela pede que você toque em Confirmar.',
  },
  {id:'2026-10-04-meu-negocio-clientes',date:'2026-10-04T15:30:00Z',tag:'novidade',title:'Seus clientes num lugar só',text:'Profissional: em Meu negócio, veja quem já contratou você, quantas vezes e quanto, e anote o que lembrar de cada um. Só você vê a anotação.'},
  {id:'2026-10-04-meu-negocio-estoque',date:'2026-10-04T15:20:00Z',tag:'novidade',title:'Estoque e orçamento mais rápido',text:'Profissional: guarde seus materiais e seus preços, e monte o orçamento puxando do estoque, da tabela ou de um modelo pronto.'},
  {id:'2026-10-04-meu-negocio-financeiro',date:'2026-10-04T15:10:00Z',tag:'novidade',title:'Quanto sobrou no mês',text:'Profissional: anote despesas e serviços feitos por fora e veja quanto sobrou para você no mês, junto com o que entrou pelo app.'},
  {id:'2026-10-04-termos-ferramentas',date:'2026-10-04T15:00:00Z',tag:'melhoria',title:'Termos e Privacidade atualizados',text:'Explicamos as novas ferramentas do profissional e o que cada uma guarda.'},
  {
    id: '2026-10-04-aviso-atualizacao',
    date: '2026-10-04T12:00:00Z',
    tag: 'melhoria',
    title: 'Aviso de versão nova',
    text: 'Quando sair uma versão nova do Chama Um, aparece um aviso. Você escolhe atualizar na hora ou depois, sem perder o que estava fazendo.',
  },
  {
    id: '2026-10-03-quero-trabalhar-celular',
    date: '2026-10-03T15:00:00Z',
    tag: 'correcao',
    title: 'Quero trabalhar no celular',
    text: 'No celular, o convite para trabalhar como profissional não aparecia. Agora ele está no menu Conta, no topo da tela.',
  },
  {
    id: '2026-10-03-pagamento-estavel',
    date: '2026-10-03T21:30:00Z',
    tag: 'melhoria',
    title: 'Pagamento mais estável',
    text: 'Você informa seus dados de pagamento uma vez só. Se um meio de pagamento estiver com problema, o app resolve sozinho e, no cartão, já oferece o Pix pelo mesmo valor.',
  },
  {
    id: '2026-10-03-pix-asaas',
    date: '2026-10-03T21:00:00Z',
    tag: 'melhoria',
    title: 'Pix por um novo parceiro',
    text: 'O Pix pode passar a ser processado pelo Asaas, com tarifa menor para o profissional. Quando for o caso, pedimos o seu CPF uma vez, e ele não fica guardado no Chama Um. Os Termos e a Política de Privacidade explicam como funciona.',
  },
  {
    id: '2026-10-03-privacidade-suporte',
    date: '2026-10-03T20:00:00Z',
    tag: 'melhoria',
    title: 'Mais clareza sobre o suporte',
    text: 'A Política de Privacidade agora explica como funcionam as conversas com a Ana, nossa assistente de ajuda, quem da equipe pode ler essas conversas e quando o responsável pela plataforma pode abrir o app vendo o mesmo que você para resolver um problema.',
  },
  {
    id: '2026-10-03-minha-casa',
    date: '2026-10-03T15:00:00Z',
    tag: 'novidade',
    title: 'Minha casa: sua equipe e tudo o que foi feito',
    text: 'Na nova aba Minha casa ficam os profissionais que já trabalharam para você, com um toque para chamar de novo, e o caderno da casa com cada serviço concluído, fotos e recibos.',
  },
  {
    id: '2026-10-03-manutencao-e-recorrente',
    date: '2026-10-03T15:01:00Z',
    tag: 'novidade',
    title: 'Lembretes de manutenção e serviços que se repetem',
    text: 'Avisamos quando costuma ser hora de repetir serviços como limpeza do ar-condicionado ou da caixa d’água. E dá para repetir um serviço toda semana, a cada 15 dias ou todo mês com o mesmo profissional: o pedido abre sozinho e você aprova antes de pagar.',
  },
  {
    id: '2026-10-03-familia',
    date: '2026-10-03T15:02:00Z',
    tag: 'novidade',
    title: 'Um familiar pode acompanhar seus pedidos',
    text: 'Convide um filho, uma filha ou um cuidador para acompanhar seus pedidos e receber os avisos importantes. A pessoa não vê seu endereço nem suas conversas, e você encerra quando quiser.',
  },
  {
    id: '2026-10-03-aviso-contato-externo',
    date: '2026-10-03T15:03:00Z',
    tag: 'melhoria',
    title: 'Mais proteção na conversa do serviço',
    text: 'Se alguém passar telefone ou chave Pix na conversa, o app lembra os dois de que, combinando por fora, perdem o dinheiro guardado e a ajuda da equipe. Também dá para denunciar quem pedir pagamento por fora.',
  },
  {
    id: '2026-10-03-termos-retencao',
    date: '2026-10-03T15:04:00Z',
    tag: 'melhoria',
    title: 'Termos e Privacidade atualizados',
    text: 'Explicamos Minha casa, os serviços recorrentes, o acompanhamento por familiares e o aviso de contato fora do app.',
  },
  {
    id: '2026-10-03-entrar-com-google',
    date: '2026-10-03T12:00:00Z',
    tag: 'novidade',
    title: 'Entre e crie sua conta com o Google',
    text: 'Agora dá para criar conta e entrar com sua conta Google, sem inventar mais uma senha. Se você já tem conta com o mesmo e-mail, ela é a mesma: continue entrando do jeito que preferir.',
  },
  {
    id: '2026-10-03-tarifa-no-pix',
    date: '2026-10-03T01:45:00Z',
    tag: 'melhoria',
    title: 'Pague a tarifa de pagamento devolvido com Pix',
    text: 'Profissional: se um pagamento voltou para o cliente por um cancelamento seu, a tarifa do banco agora pode ser paga com Pix em Pagamentos, sem esperar o próximo repasse. Tarifa sem pagar há mais de 30 dias impede enviar orçamentos novos.',
  },
  {
    id: '2026-10-03-cartao-guardado',
    date: '2026-10-03T01:30:00Z',
    tag: 'novidade',
    title: 'Guarde seu cartão e pague com um toque',
    text: 'Agora você pode guardar seu cartão em «Formas de pagamento». Na hora de aceitar um orçamento, o botão já mostra o valor e o cartão: um toque aceita e paga. Se preferir Pix, o código aparece na hora.',
  },
  {
    id: '2026-10-02-beleza-e-outros',
    date: '2026-10-02T23:58:00Z',
    tag: 'novidade',
    title: 'Beleza em casa e outros serviços',
    text: 'Agora dá para chamar manicure, cabeleireira, maquiadora e mais, no seu endereço. E se o serviço que você procura não está na lista, escreva com suas palavras: a busca encontra quem faz.',
  },
  {
    id: '2026-10-02-ajuda-no-topo',
    date: '2026-10-02T23:55:00Z',
    tag: 'melhoria',
    title: 'Ajuda no alto da tela',
    text: 'No celular, o botão para falar com a Ana agora fica no alto da tela, em «Ajuda», e não cobre mais os botões no fim da página.',
  },
  {
    id: '2026-10-02-instalar',
    date: '2026-10-02T23:50:00Z',
    tag: 'novidade',
    title: 'Chama Um na tela inicial',
    text: 'Na tela de início aparece um convite discreto para pôr o Chama Um na tela inicial do celular e abrir num toque. Se não quiser agora, toque em «Agora não».',
  },
  {
    id: '2026-10-02-avisos-a-vista',
    date: '2026-10-02T23:45:00Z',
    tag: 'correcao',
    title: 'Avisos sempre à vista',
    text: 'Quando falta preencher algo, o aviso aparece perto do botão que você tocou. Não precisa mais subir a tela para descobrir o que faltou.',
  },
  {
    id: '2026-10-02-faltas-e-tarifas',
    date: '2026-10-02T23:45:00Z',
    tag: 'melhoria',
    title: 'Mais proteção quando o profissional falta',
    text: 'Se o horário marcado passar há mais de uma hora e o serviço não começar, você pode cancelar e recebe tudo de volta. Para profissionais: o extrato agora mostra a tarifa descontada quando um pagamento volta ao cliente por cancelamento, falta ou contestação.',
  },
  {
    id: '2026-10-02-cartao-mais-seguro',
    date: '2026-10-02T23:30:00Z',
    tag: 'melhoria',
    title: 'Pagamento no cartão mais seguro',
    text: 'Agora o seu banco pede que você confirme a compra no cartão, e o recibo mostra como ela aparece na fatura. Se algo der errado no serviço, abra uma contestação no app: é mais rápido do que pedir ao banco. No primeiro serviço, o cartão vale até R$ 1.000; acima disso, use o Pix.',
  },
  {
    id: '2026-10-02-termos-privacidade',
    date: '2026-10-02T21:00:00Z',
    tag: 'correcao',
    title: 'Termos de Uso e Política de Privacidade para ler',
    text: 'No cadastro, agora dá para abrir e ler os Termos de Uso e a Política de Privacidade antes de aceitar. Eles também ficam em chamaum.app/termos e /privacidade.',
  },
  {
    id: '2026-10-02-dia-do-repasse',
    date: '2026-10-02T19:30:00Z',
    tag: 'melhoria',
    title: 'Saiba quando o dinheiro cai na conta',
    text: 'Profissional: a tela do seu plano agora mostra em que dia o dinheiro dos serviços chega na sua conta bancária.',
  },
  {
    id: '2026-10-02-acabamento',
    date: '2026-10-03T00:30:00Z',
    tag: 'melhoria',
    title: 'Acabamento em todo o app',
    text: 'A tela inicial de quem trabalha ganhou boas-vindas como a de quem contrata. Com letra grande, a lista do que falta e a barra de baixo não se espremem mais. Botão que ainda não pode ser usado aparece em cinza, sem parecer erro, e os números vêm escritos certinho: "1 dia", "3 pedidos".',
  },
  {
    id: '2026-10-02-area-do-profissional',
    date: '2026-10-02T23:30:00Z',
    tag: 'melhoria',
    title: 'Área do profissional mais clara',
    text: 'Para quem trabalha pelo app: o cadastro mostra o que já está feito e o que falta, o orçamento mostra na hora quanto entra na sua conta, e a agenda resume a sua semana num olhar.',
  },
  {
    id: '2026-10-02-pedido-mais-claro',
    date: '2026-10-02T22:00:00Z',
    tag: 'melhoria',
    title: 'Seu pedido mostra o que fazer agora',
    text: 'No topo de cada pedido aparecem as etapas, o valor combinado, o horário e o próximo passo. A conversa ficou em balões, e a nota da avaliação se escolhe com um toque.',
  },
  {
    id: '2026-10-02-busca-e-perfil',
    date: '2026-10-02T19:00:00Z',
    tag: 'melhoria',
    title: 'Busca e perfil mais fáceis de usar',
    text: 'Os filtros em uso aparecem acima dos resultados e saem com um toque. No celular, os filtros ficam numa gaveta para os profissionais aparecerem logo. O perfil mostra de cara o que a equipe conferiu.',
  },
  {
    id: '2026-10-02-pagina-inicial',
    date: '2026-10-02T15:00:00Z',
    tag: 'melhoria',
    title: 'Página inicial nova',
    text: 'A página de entrada mostra o que a equipe confere em cada profissional, ' +
      'como o seu dinheiro fica guardado até o serviço terminar e os 23 serviços ' +
      'que você pode pedir. Dá até para testar letra maior e alto contraste ali mesmo.',
  },
  {
    id: '2026-10-02-ajustes-de-leitura',
    date: '2026-10-02T12:00:00Z',
    tag: 'melhoria',
    title: 'Letra, contraste e animações no topo de toda tela',
    text: 'Toque em "Leitura", no alto da tela, para aumentar a letra, ligar o ' +
      'alto contraste ou reduzir as animações. Vale na hora, mesmo sem conta. ' +
      'O app também ganhou cara nova e ficou mais rápido para abrir.',
  },
  {
    id: '2026-10-01-trocar-email',
    date: '2026-10-01T00:00:00Z',
    tag: 'novidade',
    title: 'Troque o e-mail da sua conta',
    text: 'Em Meus dados, toque em "Trocar de e-mail". Mandamos um link ' +
      'para o endereço novo, e a conta só muda quando você abrir o link.',
  },
  {
    id: '2026-09-30-vitrine-aberta',
    date: '2026-09-30T00:00:00Z',
    tag: 'novidade',
    title: 'Veja os profissionais antes de criar conta',
    text: 'Agora dá para buscar profissionais e abrir o perfil de cada um sem entrar. A conta só é pedida na hora de pedir orçamento. O perfil também ganhou o botão Compartilhar, para mandar o link a alguém.',
  },
  {
    id: '2026-09-29-voltar-e-achar',
    date: '2026-09-29T23:30:00Z',
    tag: 'novidade',
    title: 'Ache seus pedidos e chame de novo',
    text: 'O início mostra os pedidos que estão andando. Em Meus pedidos dá para filtrar pela situação e procurar pelo nome do serviço. Serviço concluído tem o botão Contratar de novo, e você pode guardar profissionais nos favoritos para chamar outra vez.',
  },
  {
    id: '2026-09-29-avisos-celular',
    date: '2026-09-29T23:00:00Z',
    tag: 'novidade',
    title: 'Avisos no celular',
    text: 'Em Conta, ative os avisos neste aparelho: o celular avisa quando chega mensagem, orçamento ou mudança de horário, mesmo com o app fechado.',
  },
  {
    id: '2026-09-29-conversas',
    date: '2026-09-29T22:30:00Z',
    tag: 'novidade',
    title: 'Todas as conversas num lugar só',
    text: 'O botão Conversas, no topo, reúne as mensagens de todos os seus pedidos e mostra quantas você ainda não leu.',
  },
  {
    id: '2026-09-29-painel-pro',
    date: '2026-09-29T22:00:00Z',
    tag: 'novidade',
    title: 'Seu início como profissional',
    text: 'Quem trabalha pelo app agora tem uma página de início: o que falta para receber pedidos, os serviços que esperam por você, o que está marcado na semana e quanto você tem a receber. A agenda também passou a mostrar seus compromissos dos próximos 30 dias, separados por dia.',
  },
  {
    id: '2026-09-29-cartao-recibo',
    date: '2026-09-29T21:00:00Z',
    tag: 'novidade',
    title: 'Pague com cartão e guarde o recibo',
    text: 'Além do Pix, agora você pode pagar o serviço com cartão. O Pix também ganhou QR Code para quem paga com outro celular. E depois de pagar, o recibo fica no serviço, pronto para imprimir ou salvar em PDF.',
  },
  {
    id: '2026-09-29-email-confirmado',
    date: '2026-09-29T19:00:00Z',
    tag: 'novidade',
    title: 'Confirme o seu e-mail',
    text: 'Ao criar a conta, mandamos um link para confirmar o seu e-mail. Você pode usar o app sem isso, mas quem trabalha pelo Chama Um precisa confirmar para aparecer na busca e receber pagamentos. Profissionais com e-mail confirmado ganham um selo no perfil. Se não achar o link, peça outro em Meus dados.',
  },
  {
    id: '2026-09-29-prazos',
    date: '2026-09-29T18:00:00Z',
    tag: 'melhoria',
    title: 'Nenhum serviço fica esquecido',
    text: 'Se o serviço foi combinado e ninguém marcou o horário, avisamos vocês dois. Passados 7 dias sem horário, o pedido é encerrado e o que foi pago volta para você. Se o horário passou e o serviço não começou, perguntamos o que houve e nossa equipe entra em contato. E desmarcar o horário agora deixa o serviço pronto para marcar outro.',
  },
  {
    id: '2026-09-29-menos-tropecos',
    date: '2026-09-29T15:00:00Z',
    tag: 'melhoria',
    title: 'Menos tropeços no caminho',
    text: 'Depois de entrar na conta, você volta para a página que estava abrindo. Dá para cadastrar um endereço novo sem sair do pedido. Se a internet falhar, a tela avisa e oferece tentar de novo, em vez de parecer vazia. E você fica sabendo antes de tocar em "Pagar" se o pagamento pelo app está disponível.',
  },
  {
    id: '2026-09-29-cancelar-devolve',
    date: '2026-09-29T12:00:00Z',
    tag: 'melhoria',
    title: 'Cancelou antes de começar? O dinheiro volta sozinho',
    text: 'Se você pagou pelo app e cancela o serviço antes de ele começar, devolvemos o valor automaticamente e desmarcamos o horário. Se quem cancela é o profissional, você recebe tudo de volta. E a outra pessoa é avisada na hora.',
  },
  {
    id: '2026-09-28-mais-servicos',
    date: '2026-09-28T22:30:00Z',
    tag: 'novidade',
    title: 'Mais tipos de serviço para a sua casa',
    text: 'Agora você também encontra quem faz limpeza, jardinagem, dedetização, telhado, vidros, serralheria, alvenaria, pisos, gesso, piscina, segurança eletrônica, conserto de eletrodomésticos e ajuda com wi-fi, celular e TV. Cada um tem uma página com o que perguntar antes de chamar.',
  },
  {
    id: '2026-09-24-ana',
    date: '2026-09-24T12:00:00Z',
    tag: 'novidade',
    title: 'Tire dúvidas com a Ana',
    text: 'Agora tem um botão de conversa no canto da tela. A Ana, assistente virtual, responde na hora e chama o Arlindo quando precisa de uma pessoa.',
  },
  {
    id: '2026-09-23-avisos-whatsapp',
    date: '2026-09-23T15:00:00Z',
    tag: 'novidade',
    title: 'Avisos pelo WhatsApp',
    text: 'Confirme seu celular em Preferências e receba no WhatsApp o que tem pressa: pedido novo, orçamento, horário marcado e um lembrete antes do serviço. Para parar, é só responder SAIR.',
  },
  {
    id: '2026-09-23-selo-conta-receber',
    date: '2026-09-23T12:00:00Z',
    tag: 'correcao',
    title: 'Situação da conta para receber mais clara',
    text: 'Quem ainda não cadastrou os dados bancários agora vê «Não cadastrada», e não mais «Em conferência».',
  },
  {
    id: '2026-09-22-foto-conversa',
    date: '2026-09-22T09:00:00Z',
    tag: 'novidade',
    title: 'Mande fotos na conversa',
    text: 'Agora dá para mandar foto direto na conversa do serviço — o vazamento, a tomada queimada, o modelo da peça. Só você e a outra pessoa veem essas fotos.',
  },
  {
    id: '2026-09-22-pagina-servico',
    date: '2026-09-22T08:58:00Z',
    tag: 'melhoria',
    title: 'Saiba o que perguntar antes de chamar',
    text: 'Cada tipo de serviço ganhou uma página com o que vale a pena perguntar, o que costuma dar errado e quando o serviço exige um profissional com registro.',
  },
  {
    id: '2026-09-22-corrigir-avaliacao',
    date: '2026-09-22T08:57:00Z',
    tag: 'melhoria',
    title: 'Corrija uma avaliação que você escreveu',
    text: 'Errou a nota ou escreveu no calor do momento? Em Minha conta dá para corrigir a avaliação por até 7 dias. Guardamos a versão anterior, o que protege você de pressão para mudar uma nota depois.',
  },
  {
    id: '2026-09-22-agenda-folgas',
    date: '2026-09-22T08:55:00Z',
    tag: 'novidade',
    title: 'Marque suas folgas e mude horários combinados',
    text: 'Na sua agenda você já pode marcar férias e folgas — nesses períodos ninguém consegue agendar com você. E, na tela do serviço, dá para desmarcar ou mudar o horário combinado, além de colocar o compromisso no calendário do celular.',
  },
  {
    id: '2026-09-22-avaliacoes-perfil',
    date: '2026-09-22T08:50:00Z',
    tag: 'novidade',
    title: 'Leia as avaliações antes de escolher',
    text: 'O perfil de cada profissional agora mostra o que os clientes escreveram, não só a nota. Quem trabalha pelo app pode responder cada avaliação, e você também vê como os profissionais avaliaram você.',
  },
  {
    id: '2026-09-22-recusar-orcamento',
    date: '2026-09-22T08:45:00Z',
    tag: 'melhoria',
    title: 'Recuse o que não serve e corrija o que você pediu',
    text: 'Agora dá para recusar um orçamento que não interessa e deixar a lista só com os que você está comparando. Enquanto ninguém orçou, você também pode corrigir o texto do seu pedido.',
  },
  {
    id: '2026-09-22-meus-dados',
    date: '2026-09-22T08:40:00Z',
    tag: 'novidade',
    title: 'Baixe seus dados ou encerre sua conta',
    text: 'Em Minha conta, na tela Meus dados, você pode baixar tudo o que guardamos sobre você e também encerrar sua conta quando quiser. A tela explica antes o que continua guardado por obrigação legal.',
  },
  {
    id: '2026-09-22-contestar',
    date: '2026-09-22T08:30:00Z',
    tag: 'novidade',
    title: 'Se o serviço não sair como combinado, conteste',
    text: 'Na tela do serviço agora existe "Algo deu errado?". Contestar segura o pagamento até a nossa equipe ouvir os dois lados — ninguém recebe e nada é devolvido até a análise terminar.',
  },
  {
    id: '2026-09-22-bloquear',
    date: '2026-09-22T08:25:00Z',
    tag: 'novidade',
    title: 'Bloqueie quem você não quer por perto',
    text: 'Bloquear vale na hora e não depende de ninguém concordar: vocês não são mais aproximados pelo app. Você também pode denunciar quem te tratou mal. Em Minha conta, na tela Segurança, dá para ver e desfazer.',
  },
  {
    id: '2026-09-22-pagar-pix',
    date: '2026-09-22T08:20:00Z',
    tag: 'novidade',
    title: 'Pague pelo app, com segurança',
    text: 'Depois de aceitar um orçamento você já pode pagar por Pix aqui mesmo. O dinheiro fica guardado com a gente e só vai para o profissional depois que o serviço estiver feito e você confirmar. Se algo der errado, dá para pedir de volta.',
  },
  {
    id: '2026-09-22-recebimentos',
    date: '2026-09-22T08:15:00Z',
    tag: 'novidade',
    title: 'Acompanhe seus recebimentos',
    text: 'Em Seus recebimentos você cadastra a conta onde quer receber e vê o extrato: o que já caiu, o que está guardado esperando a confirmação do cliente e quando cada valor sai.',
  },
  {
    id: '2026-09-22-portfolio',
    date: '2026-09-22T08:10:00Z',
    tag: 'novidade',
    title: 'Mostre os serviços que você já fez',
    text: 'No seu cadastro de profissional você já pode cadastrar trabalhos anteriores com fotos de antes e depois. Eles aparecem no seu perfil para quem está escolhendo quem chamar.',
  },
  {
    id: '2026-09-22-certificados',
    date: '2026-09-22T08:05:00Z',
    tag: 'novidade',
    title: 'Envie seus certificados e documentos',
    text: 'Agora dá para mandar seus certificados, cursos e documentos direto pelo app, e acompanhar o que já foi conferido pela nossa equipe. O certificado aprovado aparece no seu perfil; a foto dele fica em sigilo.',
  },
  {
    id: '2026-09-22-como-atende',
    date: '2026-09-22T08:00:00Z',
    tag: 'novidade',
    title: 'Diga como você atende',
    text: 'No seu cadastro você marca o que oferece a quem precisa: Libras, acompanhante, paciência com quem ouve pouco. É assim que quem procura por isso encontra você na busca.',
  },
  {
    id: '2026-09-22-foto-perfil',
    date: '2026-09-22T07:50:00Z',
    tag: 'novidade',
    title: 'Coloque sua foto no perfil',
    text: 'Em Minha conta você já pode escolher uma foto do seu rosto. Ela ajuda quem vai abrir a porta a reconhecer você e, se você trabalha pelo app, aparece para os clientes na busca.',
  },
  {
    id: '2026-09-22-senha',
    date: '2026-09-22T07:45:00Z',
    tag: 'novidade',
    title: 'Esqueceu a senha? Agora dá para recuperar sozinho',
    text: 'Na tela de entrar existe "Esqueci minha senha": você recebe um link por e-mail e cria uma senha nova. E, dentro de Minha conta, você pode trocar a senha quando quiser.',
  },
  {
    id: '2026-09-21-casa-em-boas-maos',
    date: '2026-09-21T08:00:00Z',
    tag: 'melhoria',
    title: 'O Chama Um está mais claro e mais fácil de usar',
    text: 'Renovamos as telas com mais espaço, botões e textos mais fáceis de encontrar e uma navegação pensada para celular e computador. A letra grande, o alto contraste e o movimento reduzido continuam disponíveis em todo o app.',
  },
  {
    id: '2026-09-20-avisos',
    date: '2026-09-20T21:00:00Z',
    tag: 'novidade',
    title: 'Agora o app te avisa',
    text: 'Você não precisa mais ficar abrindo o app para ver se aconteceu alguma coisa. Orçamento recebido, horário marcado, serviço concluído, pagamento liberado: tudo aparece em Avisos, e também chega no seu e-mail.',
  },
  {
    id: '2026-09-20-escolher-emails',
    date: '2026-09-20T20:50:00Z',
    tag: 'novidade',
    title: 'Escolha quais e-mails quer receber',
    text: 'Em Minha conta você marca o que quer receber por e-mail. Avisos sobre a sua conta e sobre dinheiro continuam sempre chegando, porque são coisas que você precisa saber.',
  },
  {
    id: '2026-09-20-contestar',
    date: '2026-09-20T18:00:00Z',
    tag: 'novidade',
    title: 'Deu problema no serviço? Agora você pode contestar',
    text: 'Se o serviço não ficou como combinado, você abre uma contestação pela tela do serviço. O pagamento fica retido na hora e a nossa equipe analisa os dois lados antes de decidir. Vale para quem contrata e para quem trabalha.',
  },
  {
    id: '2026-09-20-repasse-automatico',
    date: '2026-09-20T17:30:00Z',
    tag: 'correcao',
    title: 'O profissional recebe mesmo se o cliente esquecer de confirmar',
    text: 'O pagamento de um serviço que ficou sem confirmação podia ficar parado. Agora, passados três dias da conclusão, o serviço é confirmado sozinho e o repasse sai normalmente.',
  },
  {
    id: '2026-09-21-servico-andamento',
    date: '2026-09-21T04:00:00Z',
    tag: 'novidade',
    title: 'A tela do serviço agora mostra tudo e deixa agir',
    text: 'Depois que você escolhe o profissional, a tela passa a mostrar o endereço com link para o mapa, o valor combinado, a data e hora marcadas e as fotos do serviço. Dá para combinar o horário, acompanhar o começo, ver a foto do serviço pronto e cancelar, dos dois lados.',
  },
  {
    id: '2026-09-21-agenda-pro',
    date: '2026-09-21T03:50:00Z',
    tag: 'novidade',
    title: 'Profissional: diga os dias e horários em que você atende',
    text: 'Em "Minha agenda" você marca as faixas de horário de cada dia da semana. É isso que permite o cliente combinar o horário com você — sem, ele escolhe seu orçamento e fica sem conseguir marcar.',
  },
  {
    id: '2026-09-21-conta-profissional',
    date: '2026-09-21T03:00:00Z',
    tag: 'novidade',
    title: 'Quem trabalha no Chama Um agora edita seus dados em Minha conta',
    text: 'Nome, apresentação, anos de experiência, raio de atendimento e emergência ficam todos em Minha conta. O raio e a emergência valem na hora. Já o nome e a apresentação passam pela nossa equipe antes de entrar no ar — é o que quem contrata lê para decidir se abre a porta de casa. Enquanto isso, seu perfil continua no ar como está.',
  },
  {
    id: '2026-09-21-pedir-para-alguem',
    date: '2026-09-21T02:00:00Z',
    tag: 'correcao',
    title: 'Pedir orçamento para um profissional agora funciona',
    text: 'O botão "Pedir orçamento" na página de um profissional levava de volta para a lista de busca. Agora ele abre o pedido já com essa pessoa escolhida, e só ela recebe. Se ela não atender o serviço, a cidade ou os cuidados que você marcou, a gente avisa na hora e diz o motivo.',
  },
  {
    id: '2026-09-21-cuidados-marcam',
    date: '2026-09-21T01:00:00Z',
    tag: 'correcao',
    title: 'Os cuidados no atendimento voltaram a marcar',
    text: 'No pedido de serviço, marcar "Atende em Libras", "Paciência com pessoa idosa" e os outros cuidados não estava funcionando: a caixa não ficava marcada e o pedido era recusado no fim. Agora marca, desmarca e envia direito.',
  },
  {
    id: '2026-09-20-cep',
    date: '2026-09-20T23:30:00Z',
    tag: 'novidade',
    title: 'Agora é só digitar o CEP',
    text: 'No cadastro de endereço, digite o CEP e a rua, o bairro e a cidade se preenchem sozinhos. Você só completa o número. Se preferir, pode continuar preenchendo tudo à mão.',
  },
  {
    id: '2026-09-20-todas-as-cidades',
    date: '2026-09-20T23:20:00Z',
    tag: 'correcao',
    title: 'Todas as cidades do Brasil aparecem na busca',
    text: 'Antes só as capitais e as cidades maiores apareciam quando você digitava. Agora estão todos os 5.571 municípios.',
  },
  {
    id: '2026-09-20-cara-nova',
    date: '2026-09-20T22:00:00Z',
    tag: 'melhoria',
    title: 'O Chama Um está com a cara nova',
    text: 'Telas redesenhadas com letra maior, mais espaço e linhas mais fortes, para ficar mais fácil de ler. O alto contraste e a letra grande continuam funcionando em tudo, do mesmo jeito.',
  },
  {
    id: '2026-09-20-sair-da-conta',
    date: '2026-09-20T19:30:00Z',
    tag: 'correcao',
    title: 'Agora dá para sair da conta',
    text: 'O botão "Sair" aparece no menu do topo, com o seu nome do lado — útil quando mais de uma pessoa usa o mesmo aparelho.',
  },
  {
    id: '2026-09-20-cliente-ou-profissional',
    date: '2026-09-20T19:00:00Z',
    tag: 'novidade',
    title: 'No cadastro, você diz se quer contratar ou trabalhar',
    text: 'É a mesma conta para as duas coisas. Quem escolhe trabalhar já entra direto na continuação do cadastro de profissional: tipos de serviço, cidades onde atende e envio para a nossa equipe conferir.',
  },
  {
    id: '2026-09-20-avaliacao-dos-dois-lados',
    date: '2026-09-20T18:00:00Z',
    tag: 'novidade',
    title: 'Agora a avaliação é dos dois lados',
    text: 'Quem contrata avalia o profissional, e o profissional também avalia como foi o atendimento. Sua nota como cliente não aparece em página pública: ela só é vista por quem vai até a sua casa.',
  },
  {
    id: '2026-09-20-buscar-com-conta',
    date: '2026-09-20T17:30:00Z',
    tag: 'melhoria',
    title: 'Para ver os profissionais, é preciso ter conta',
    text: 'O cadastro é gratuito e leva um minuto, e a busca aparece assim que você entra. Antes disso a tela convida você a criar a conta, em vez de oferecer um botão que não levaria a lugar nenhum.',
  },
  {
    id: '2026-09-20-painel-equipe',
    date: '2026-09-20T12:00:00Z',
    tag: 'novidade',
    title: 'Painel para a nossa equipe conferir cadastros',
    text: 'A equipe do Chama Um agora tem uma tela própria para conferir os documentos e certificados de quem se cadastra como profissional. É esse cuidado que faz o selo de verificado significar alguma coisa.',
  },
  {
    id: '2026-09-20-telas-pedido',
    date: '2026-09-20T09:00:00Z',
    tag: 'novidade',
    title: 'Pedir um serviço ficou mais simples',
    text: 'O pedido agora é feito em quatro passos curtos, um assunto de cada vez. Você diz o que precisa, conta o que está acontecendo, escolhe o endereço e a urgência — e pode marcar se precisa de algum cuidado especial no atendimento.',
  },
  {
    id: '2026-09-20-instalar-app',
    date: '2026-09-20T07:00:00Z',
    tag: 'novidade',
    title: 'Instale o Chama Um no seu celular',
    text: 'Agora dá para instalar o app na tela inicial do celular, como qualquer outro aplicativo. Ele abre mais rápido e funciona melhor quando a internet está fraca.',
  },
  {
    id: '2026-09-20-seus-dados',
    date: '2026-09-20T06:30:00Z',
    tag: 'novidade',
    title: 'Baixe seus dados ou encerre sua conta',
    text: 'Em Conta > Privacidade você pode baixar uma cópia de tudo o que guardamos sobre você, ou encerrar sua conta. Também pode denunciar comportamento inadequado e bloquear alguém com quem você não quer mais lidar.',
  },
  {
    id: '2026-09-20-avaliacoes',
    date: '2026-09-20T05:00:00Z',
    tag: 'novidade',
    title: 'Avalie o serviço e ajude quem vem depois',
    text: 'Depois que o serviço termina, você dá uma nota e conta como foi. Pode dizer também se o profissional cumpriu o que prometeu em acessibilidade — é isso que ajuda a próxima pessoa a escolher com segurança. O profissional pode responder, e você tem 7 dias para mudar de ideia.',
  },
  {
    id: '2026-09-20-pagamento',
    date: '2026-09-20T03:00:00Z',
    tag: 'novidade',
    title: 'Pague pelo app com segurança',
    text: 'Você pode pagar por Pix ou cartão dentro do app. O dinheiro fica retido com a gente e só é repassado ao profissional depois que o serviço estiver pronto e você confirmar. Se algo der errado, você tem 3 dias para reclamar.',
  },
  {
    id: '2026-09-20-agendamento',
    date: '2026-09-20T01:00:00Z',
    tag: 'novidade',
    title: 'Marque dia e hora com o profissional',
    text: 'Depois de escolher o profissional, você vê os horários livres dele e marca. Dá para remarcar ou cancelar, e você pode salvar o compromisso no calendário do celular.',
  },
  {
    id: '2026-09-19-chat',
    date: '2026-09-19T23:30:00Z',
    tag: 'novidade',
    title: 'Converse pelo app, sem dar seu telefone',
    text: 'Depois de escolher o profissional, vocês combinam tudo por mensagem aqui mesmo. Você pode mandar fotos, e fica tudo registrado — se der algum problema, a nossa equipe consegue ver o que foi combinado.',
  },
  {
    id: '2026-09-19-pedido-orcamento',
    date: '2026-09-19T22:00:00Z',
    tag: 'novidade',
    title: 'Peça orçamento e compare propostas',
    text: 'Descreva o que você precisa e receba orçamentos de profissionais da sua cidade. Você compara os valores lado a lado e escolhe. Seu endereço completo só é mostrado depois que você escolhe alguém.',
  },
  {
    id: '2026-09-19-portfolio-certificados',
    date: '2026-09-19T20:00:00Z',
    tag: 'novidade',
    title: 'Mostre seus certificados e trabalhos',
    text: 'Profissionais podem enviar certificados (como a NR-10) e fotos de serviços já feitos. Nossa equipe confere os documentos antes de liberar o perfil — e o selo de verificado aparece para quem contrata.',
  },
  {
    id: '2026-09-19-busca-acessibilidade',
    date: '2026-09-19T18:00:00Z',
    tag: 'novidade',
    title: 'Busque por quem atende sua necessidade',
    text: 'Agora você pode filtrar profissionais por cidade, tipo de serviço e por necessidades de acessibilidade — como atender em Libras, ter paciência com pessoa idosa ou combinar tudo por escrito.',
  },
  {
    id: '2026-09-19-perfil-profissional',
    date: '2026-09-19T17:30:00Z',
    tag: 'novidade',
    title: 'Monte seu perfil de profissional',
    text: 'Se você presta serviços, pode criar seu perfil na mesma conta: escolha os tipos de serviço, as cidades onde atende e o que você se compromete a atender em acessibilidade.',
  },
  {
    id: '2026-09-19-acessibilidade',
    date: '2026-09-19T12:00:00Z',
    tag: 'novidade',
    title: 'Ajuste o app do seu jeito',
    text: 'Em Conta > Acessibilidade você pode aumentar a letra, ligar o contraste alto e reduzir animações. A escolha fica salva e acompanha você em qualquer aparelho.',
  },
];

export const ROTULO_TAG: Record<TagChangelog, string> = {
  novidade: 'Novidade',
  melhoria: 'Melhoria',
  correcao: 'Correção',
};

/**
 * Entradas ainda nao vistas por quem tem esse `changelog_visto_em`.
 *
 * Entrada com data no FUTURO nunca conta como não vista, e o motivo é concreto:
 * `changelog_visto_em` é gravado com o instante do clique, então uma entrada
 * datada para amanhã continuaria "não vista" depois de a pessoa fechar o popup
 * -- e o popup voltaria a cada visita, para todo mundo, até a data chegar.
 * Errar a data em uma linha do arquivo é fácil; deixar isso virar um popup
 * que não fecha, não.
 */
export function naoVistas(
  vistoEm: number | null | undefined, agoraMs: number = Date.now(),
): EntradaChangelog[] {
  const publicadas = CHANGELOG.filter((e) => Date.parse(e.date) <= agoraMs);
  if (!vistoEm) return publicadas;
  const corte = vistoEm * 1000;
  return publicadas.filter((e) => Date.parse(e.date) > corte);
}
